import React from "react";
import Tooltip from "../../ui/Tooltip";

const DesktopHeaderBar = ({
    hides, currentHideIndex, setCurrentHideIndex,
    cutOption, setCutOption,
    isConfirmed, isOrderFinished, isConfigOpen,
    isCapturing, confirmBtnText, isConfirmDisabled,
    collisionType, hasFreeMovePurchase, isAllPreselectedUsed,
    currentHide, currentPrice, hasPreSelectedPurchase,
    handleConfirmPattern,
    setGuideTab, setIsGuideOpen,
    setIsRotateOpen,
    t,
}) => (
    <div className="d-none d-md-flex w-100 align-items-center mb-3" style={{ height: '48px', zIndex: 100 }}>
        <div className="d-flex align-items-center gap-3" style={{ flex: 1 }}>
            <div className="position-relative" id="tour-step-info">
                <div className="luxury-dropdown-container" style={{ position: 'relative' }}>
                    <select
                        className="luxury-dropdown fw-bold"
                        style={{ width: '240px', paddingLeft: '36px' }}
                        value={currentHideIndex}
                        onChange={(e) => { setCurrentHideIndex(Number(e.target.value)); }}
                        disabled={isOrderFinished || isConfigOpen}
                    >
                        {hides.map((hide, index) => (
                            <option key={hide._id} value={index} style={{ color: hide.isHidden ? '#999' : 'inherit' }}>
                                {hide.name} {hide.isHidden ? `(${t('sold_out', 'SOLD OUT')})` : ''}
                            </option>
                        ))}
                    </select>
                    <div style={{ position: 'absolute', left: '8px', top: '50%', transform: 'translateY(-50%)', zIndex: 2 }}>
                        <Tooltip
                            align="left"
                            content={
                                <div>
                                    <h6 className="mb-2 fw-bold text-uppercase" style={{ color: '#C5A075', fontSize: '0.85rem', margin: 0 }}>
                                        {currentHide.name || t('leather_type', 'Leather Type')}
                                    </h6>
                                    <div className="d-flex justify-content-between pt-2 mt-2" style={{ borderTop: '1px dashed rgba(255,255,255,0.2)', gap: '20px' }}>
                                        <span style={{ color: '#9E9690', fontSize: '0.75rem' }}>{t('leather_price', 'Leather Price:')}</span>
                                        <span className="fw-bold text-success" style={{ fontSize: '0.75rem' }}>${currentPrice}</span>
                                    </div>
                                </div>
                            }
                        >
                            <span style={{ border: '1px solid rgba(197,160,117,0.55)', borderRadius: '50%', width: '20px', height: '20px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#C5A075', fontSize: '12px', fontWeight: '700', cursor: 'default', lineHeight: 1 }}>i</span>
                        </Tooltip>
                    </div>
                </div>
            </div>

            {!isOrderFinished && (
                <div id="tour-step-cut" className="btn-group shadow-sm p-1" style={{ backgroundColor: '#fff', borderRadius: '50px', border: '1px solid rgba(233, 228, 219, 0.8)', height: '44px' }}>
                    {!hasPreSelectedPurchase && (
                        <button
                            className={`btn rounded-pill fw-bold transition-all ${cutOption === 'free' ? 'text-white' : 'btn-light bg-transparent text-muted border-0'}`}
                            onClick={() => setCutOption('free')}
                            disabled={isConfirmed}
                            style={{ fontSize: '0.85rem', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: cutOption === 'free' ? '#C5A075' : 'transparent' }}
                        >
                            <span
                                onClick={(e) => { e.stopPropagation(); setGuideTab('free'); setIsGuideOpen(true); }}
                                style={{ border: `1px solid ${cutOption === 'free' ? 'rgba(255,255,255,0.6)' : 'rgba(197,160,117,0.55)'}`, borderRadius: '50%', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: cutOption === 'free' ? '#fff' : '#C5A075', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}
                            >?</span>
                            {t('free_move', 'Free Move')}
                        </button>
                    )}
                    <button
                        className={`btn rounded-pill fw-bold transition-all ${cutOption === 'preselected' ? 'text-white' : 'btn-light bg-transparent text-muted border-0'}`}
                        onClick={() => { setCutOption('preselected'); setIsRotateOpen(false); }}
                        disabled={isConfirmed}
                        style={{ fontSize: '0.85rem', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: cutOption === 'preselected' ? '#C5A075' : 'transparent' }}
                    >
                        {hasPreSelectedPurchase && (
                            <span
                                onClick={(e) => { e.stopPropagation(); setGuideTab('preselected'); setIsGuideOpen(true); }}
                                style={{ border: `1px solid ${cutOption === 'preselected' ? 'rgba(255,255,255,0.6)' : 'rgba(197,160,117,0.55)'}`, borderRadius: '50%', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: cutOption === 'preselected' ? '#fff' : '#C5A075', fontSize: '11px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, lineHeight: 1 }}
                            >?</span>
                        )}
                        {t('pre_selected', 'Pre-selected')}
                    </button>
                </div>
            )}
        </div>

        <div className="d-flex align-items-center justify-content-end gap-2" style={{ flex: 1 }}>
            <div id="tour-step-confirm" style={{ display: 'inline-flex', flexShrink: 0 }}>
            {isOrderFinished ? (
                <button type="button" disabled
                    style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, borderRadius: '50px', backgroundColor: '#22c55e', color: '#fff', border: 'none', padding: '0 24px', height: '44px', fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.8px', cursor: 'default', boxShadow: 'none', whiteSpace: 'nowrap' }}>
                    {t('btn_design_finalized', 'DESIGN FINALIZED')}
                </button>
            ) : isConfirmed ? (
                <button type="button" disabled
                    style={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0, borderRadius: '50px', backgroundColor: '#C5A075', color: '#fff', border: 'none', padding: '0 24px', height: '44px', fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.8px', cursor: 'default', opacity: 0.8, whiteSpace: 'nowrap' }}>
                    {t('btn_confirmed', 'CONFIRMED')}
                </button>
            ) : (
                <button
                    type="button"
                    onClick={handleConfirmPattern}
                    disabled={isConfirmDisabled || currentHide.isHidden}
                    style={{
                        display: 'inline-flex', alignItems: 'center', flexShrink: 0,
                        borderRadius: '50px', border: 'none', padding: '0 24px', height: '44px',
                        backgroundColor: (collisionType || hasFreeMovePurchase || isAllPreselectedUsed || currentHide.isHidden) ? '#dc3545' : '#C5A075',
                        color: '#fff', fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.8px', whiteSpace: 'nowrap',
                        cursor: (isConfirmDisabled || currentHide.isHidden) ? 'not-allowed' : 'pointer',
                        opacity: isConfirmDisabled ? 0.7 : 1,
                        boxShadow: isConfirmDisabled ? 'none' : '0 4px 15px rgba(197,160,117,0.4)',
                        transition: 'all 0.3s cubic-bezier(0.16,1,0.3,1)',
                    }}
                >
                    {isCapturing && <span className="spinner-border spinner-border-sm me-2"></span>}
                    {currentHide.isHidden ? t('not_available', 'NOT AVAILABLE') : confirmBtnText}
                </button>
            )}
            </div>
        </div>
    </div>
);

export default DesktopHeaderBar;
